import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import styled from 'styled-components';
import i18n from '../i18n';

const placeData = (data) => {
  const { income_goal_month, real_income_month } = data;
  const monthCount = real_income_month
  const monthGoal = income_goal_month
  const monthLeft = +monthGoal - +monthCount

  return ({
    labels: [i18n.t('incomeGoal.current'), i18n.t('incomeGoal.left')],
    datasets: [
      {
        data: [+monthCount, monthLeft],
        backgroundColor: ['#47D789', '#A0A0A0'],
      },
    ],
  })
};

const IncomeGoal = (props) => {
  const { data } = props;

  return (
    <Container>
      <Header>
        <h5>{i18n.t('incomeGoal.title')}</h5>
      </Header>
      <Doughnut data={placeData(data)} />
    </Container>
  )
};

export default IncomeGoal;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Header = styled.div`
  text-align: center;
`;
